import { createFileRoute } from '@tanstack/react-router';

import { TacticalUAVPageContent } from '~/components/products/tactical-drones/TacticalUAVPageContent';

const TacticalUAVPage = () => {
  return <TacticalUAVPageContent />;
};

export const Route = createFileRoute('/$locale/products/tactical-drones')({
  component: TacticalUAVPage,
});
